import React, { useEffect, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import { toAbsoluteUrl } from "../../helpers/Reusable";
import Skeleton from "react-loading-skeleton";

// Setup worker
GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const BookPdf = (props) => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    const loadPdf = async () => {
      try {
        const pdfUrl =
          props.pdf;
        const pdf = await getDocument({ url: pdfUrl }).promise;

        // const pdfUrl = toAbsoluteUrl("media/1.pdf");
        // const pdf = await getDocument(pdfUrl).promise;

        const pageImages = [];

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 1.5 });

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          await page.render({ canvasContext: context, viewport }).promise;
          pageImages.push(canvas.toDataURL());
        }

        setPages(pageImages);
      } catch (err) {
        console.error("Error loading PDF:", err);
      }
    };

    loadPdf();
  }, [props.pdf]);

  // 👇 Prevent flipbook render until all pages are ready
  if (pages.length == 0) {
    return (
      // <div className="text-center p-6"></div>
      // <div className="min-w-[300px] min-h-[400px] xs:w-[400px] xs:h-[600px] sm:w-[450px] sm:h-[650px]">
      //     <div className="w-full h-full flex items-center justify-center bg-[#c99930]">
      //       <div className="flex flex-col items-center justify-center text-center">
      //         <img
      //           className="w-32"
      //           src={toAbsoluteUrl("media/img/logo/main-logo.svg")}
      //           alt="Book Logo"
      //         />
      //       </div>
      //     </div>
      // </div>
      <div>
        <div className="hidden xs:block">
          <Skeleton height={600} width={400} />
        </div>
        <div className="block xs:hidden">
          <Skeleton height={400} width={300} />
        </div>
      </div>
    );
  }

  return (
    <>
      {/* SOLUTION 1: Center the book and make it responsive */}
      <div className="xs:w-[400px] xs:h-[600px] sm:w-[450px] sm:h-[650px]">
        {/* Book container on a board-like background */}
        <div className="bg-[#7c5e2e] rounded-xl shadow-2xl">
          <HTMLFlipBook
            width={450} // base width
            height={650} // base height
            size="stretch" // allow scaling
            minWidth={300}
            maxWidth={450} // reduced max width for better proportion
            minHeight={400}
            maxHeight={650} // reduced max height
            maxShadowOpacity={0.5}
            mobileScrollSupport={true}
            showCover={true}
            getOrientation={"portrait"}
            className="book-flip"
          >
            {/* Front Cover */}
            <div className="w-full h-full flex items-center justify-center bg-[#c99930]">
              <div className="flex flex-col items-center justify-center text-center">
                <h1 className="mb-6 text-3xl font-bold text-white">My Book</h1>
                <img
                  className="w-32"
                  src={toAbsoluteUrl("media/img/logo/main-logo.svg")}
                  alt="Book Logo"
                />
              </div>
            </div>

            {/* PDF Pages */}
            {pages.map((img, idx) => (
              <div
                key={idx}
                className="w-full h-full bg-white flex items-center justify-center"
              >
                <img
                  src={img}
                  alt={`page-${idx + 1}`}
                  className="max-w-full max-h-full object-contain"
                />
              </div>
            ))}

            {/* Back Cover */}
            <div className="w-full h-full flex items-center justify-center bg-[#c99930]">
              {/* <h1 className="text-3xl font-bold text-white">End Book</h1> */}
              <img
                className="w-32"
                src={toAbsoluteUrl("media/img/logo/main-logo.svg")}
                alt="Book Logo"
              />
            </div>
          </HTMLFlipBook>
        </div>
      </div>
    </>
  );
};

export default BookPdf;
